exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scoped-interivew-email .user-tag{cursor:pointer;margin:5px}.scoped-interivew-email .user-tag.disabled{text-decoration:line-through;background:#ddd;color:#fff;border-color:transparent}.scoped-interivew-email .previewView{overflow:auto;height:520px}.scoped-interivew-email .quickTool .el-tag{cursor:pointer;margin-right:5px}.scoped-interivew-email .dialog-footer button{width:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-074c5078","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/operation/interviewerEmailDialog.vue
// module id = 842
// module chunks = 23